import React, { useEffect, useState } from 'react';
import MemberPicker from './MemberPicker';

const StepMembers = ({ project, setProject }) => {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    setProject({ ...project, members: selected });
  }, [selected]);

  return (
    <div>
      <MemberPicker
        selected={selected}
        setSelected={setSelected}
        description="Add or move team members to this Project. A user can only be in a single project."
      />
    </div>
  );
};

export default StepMembers;
